import React from 'react';
import classes from './pdfFooter.module.css';

function PdfFooter() {
  return React.createElement("div", {
    className: classes.footer
  }, React.createElement("div", {
    className: "px-5"
  }, React.createElement("p", {
    className: "flex-1"
  }, "Hubbardtonforge.com"), React.createElement("p", {
    className: "flex-1 text-center"
  }, "customerservice@vtforge.com"), React.createElement("p", {
    className: "flex-1 text-right"
  }, "888-826-4766")), React.createElement("div", {
    className: "flex-1 justify-center"
  }, React.createElement("p", null, "Copyright \xA9 ", new Date().getFullYear(), " Hubbardton Forge. All Rights Reserved.")));
}

export default PdfFooter;